import React, { Component } from "react";
import { FeatureGroup, Circle } from "react-leaflet";
import { EditControl } from "react-leaflet-draw";
import { withRoutes } from "../../shared/containers/containerRoutes";
import { withControlPoints } from "../../shared/containers/containerControlPoints";
import { v4 as uuidv4 } from "uuid";
import { withCreateControlPoints } from "../../shared/containers/containerCreateControlPoint";

class ControlPointTool extends Component {
  getRaiusGeozones() {
    const { controlPoints } = this.props;

    return controlPoints.map((point) => {
      const { onSetCreateControlPoint } = this.props;

      return (
        <Circle
          key={uuidv4()}
          id={point.id}
          center={[point.latitude, point.longitude]}
          radius={Number(point.radius)}
          eventHandlers={{
            click: (e) => {
              onSetCreateControlPoint(point);
            },
          }}
        />
      );
    });
  }

  setToCreateControlPoint(e) {
    const { onSetCreateControlPoint } = this.props;

    const controlPoint = {
      id: null,
      title: "Без имени",
      latitude: e.layer._latlng.lat,
      longitude: e.layer._latlng.lng,
      radius: Math.round((e.layer._mRadius / 1000 + Number.EPSILON) * 1000),
      routes: [],
    };

    onSetCreateControlPoint(controlPoint);
  }

  render() {
    const { selectedRouteId, createControlPoint, featureKey } = this.props;

    if (selectedRouteId !== null) {
      return null;
    }

    return (
      <div>
        <FeatureGroup key={featureKey}>
          <EditControl
            key={createControlPoint === null}
            position="topleft"
            onCreated={(e) => {
              this.setToCreateControlPoint(e);
            }}
            onEdited={() => {}}
            edit={{
              edit: false,
              remove: false,
            }}
            draw={{
              polyline: false,
              polygon: false,
              rectangle: false,
              circle:
                createControlPoint === null
                  ? {
                      showRadius: true,
                      metric: true,
                      feet: true,
                      nautic: true,
                    }
                  : false,
              marker: false,
              circlemarker: false,
            }}
          />
          {this.getRaiusGeozones()}
        </FeatureGroup>
      </div>
    );
  }
}

export default withCreateControlPoints(withControlPoints(withRoutes(ControlPointTool)));
